import { Carousel } from 'element-ui'

const YCarousel = Carousel
YCarousel.$depends = [Carousel]
YCarousel.$name = 'y-carousel'
YCarousel._name = 'Carousel 走马灯'

export default YCarousel
